/**
 * Demande explicite de la caméra AVANT de démarrer MindAR,
 * pour contrôler l'UX de permission et tracer accord/refus.
 * Le flux obtenu est immédiatement libéré : MindAR rouvrira le sien.
 */
export type CameraPermissionResult =
  | { granted: true }
  | { granted: false; reason: 'denied' | 'unavailable' | 'unknown' };

export async function requestCameraPermission(): Promise<CameraPermissionResult> {
  if (!navigator.mediaDevices?.getUserMedia) {
    return { granted: false, reason: 'unavailable' };
  }
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: 'environment' },
      audio: false,
    });
    stream.getTracks().forEach((t) => t.stop());
    return { granted: true };
  } catch (err) {
    const name = err instanceof DOMException ? err.name : '';
    if (name === 'NotAllowedError' || name === 'SecurityError') {
      return { granted: false, reason: 'denied' };
    }
    if (name === 'NotFoundError' || name === 'NotReadableError' || name === 'OverconstrainedError') {
      return { granted: false, reason: 'unavailable' };
    }
    return { granted: false, reason: 'unknown' };
  }
}
